import { FormattedMessage, useIntl } from 'react-intl';

import sourceMessages from '../translations/en-GB.json';

const messages = {
    title: 'intl-msg:sci.demoScenario.title',
    intro: 'intl-msg:sci.demoScenario.intro',
    environment: 'intl-msg:sci.demoScenario.environment',
    replacement: 'intl-msg:sci.demoScenario.replacement',
    json: 'intl-msg:sci.demoScenario.json',
    example: 'intl-msg:sci.demoScenario.example',
    review: 'intl-msg:sci.demoScenario.review',
    edit: 'intl-msg:sci.demoScenario.edit',
    newBatch: 'intl-msg:sci.demoScenario.newBatch',
    keepOpen: 'intl-msg:sci.demoScenario.keepOpen',
    close: 'intl-msg:sci.demoScenario.close',
    publish: 'intl-msg:sci.demoScenario.publish',
    publishing: 'intl-msg:sci.demoScenario.publishing',
    requests: 'intl-msg:sci.demoScenario.requests',
    transports: 'intl-msg:sci.demoScenario.transports',
    order: 'intl-msg:sci.demoScenario.order',
    resource: 'intl-msg:sci.demoScenario.resource',
    id: 'intl-msg:sci.demoScenario.id',
    status: 'intl-msg:sci.demoScenario.status',
    request: 'intl-msg:sci.demoScenario.request',
    transport: 'intl-msg:sci.demoScenario.transport',
    pending: 'intl-msg:sci.demoScenario.pending',
    acknowledged: 'intl-msg:sci.demoScenario.acknowledged',
    progress: 'intl-msg:sci.demoScenario.progress',
    complete: 'intl-msg:sci.demoScenario.complete',
    failed: 'intl-msg:sci.demoScenario.failed',
    auth: 'intl-msg:sci.demoScenario.auth',
    invalid: 'intl-msg:sci.demoScenario.invalid',
    projection: 'intl-msg:sci.demoScenario.projection',
} as const;
export type ScenarioMessage = keyof typeof messages;
export const SM = ({ name, values }: { name: ScenarioMessage; values?: Record<string, string | number> }) => (
    <FormattedMessage id={messages[name]} defaultMessage={sourceMessages[messages[name]]} values={values} />
);
export const useScenarioLabel = () => {
    const intl = useIntl();
    return (name: ScenarioMessage) =>
        intl.formatMessage({ id: messages[name], defaultMessage: sourceMessages[messages[name]] });
};
